export const splitByWeight = (total, weights, decimals = 6) => {
  if (!Array.isArray(weights) || weights.length === 0) return [];

  const factor = 10 ** decimals;
  const units = Math.round(Number(total || 0) * factor);
  const positive = weights.map((weight) => Math.max(Number(weight) || 0, 0));
  const weightSum = positive.reduce((sum, weight) => sum + weight, 0);
  const base = weightSum > 0 ? positive : positive.map(() => 1);
  const baseSum = weightSum > 0 ? weightSum : base.length;

  const exact = base.map((weight) => (units * weight) / baseSum);
  const shares = exact.map((value) => Math.floor(value));
  const leftover = units - shares.reduce((sum, share) => sum + share, 0);

  exact
    .map((value, index) => ({ index, remainder: value - shares[index] }))
    .sort((a, b) => b.remainder - a.remainder || a.index - b.index)
    .slice(0, leftover)
    .forEach(({ index }) => {
      shares[index] += 1;
    });

  return shares.map((share) => share / factor);
};
